import React from 'react';
import {BoilerInputProps, Input} from 'b302-frontend-library';
import { ReactComponent as IconSearch } from '../../assets/icons/icon_search.svg';

interface Props<T> extends BoilerInputProps<T> {
    type?: 'text' | 'password';
    placeholder?: string;
    onFocus?: () => void;
    onBlur?: () => void;
    className?: string;
}

function HanSearch<T>(props: Props<T>) {

    return (
        <div className={`han-search ${props.className ? props.className : ''}`}>
            <Input
                {...props}
                onChange={props.onChange}
                id={props.id}
                className={'han-search__input'}
                type={props.type}
                placeholder={props.placeholder}
                onFocus={props.onFocus}
                onBlur={props.onBlur} />

            <IconSearch />
        </div>
    )
}

export default HanSearch;
